import tippy from 'tippy.js';

/**
 * Initializes filtering, searching, and pagination for resource lists using List.js and Select2.
 *
 * - Initializes Select2 on filter dropdowns.
 * - Show or hide the list if it's initially set to be hidden.
 * - Configures List.js for filtering, sorting, and pagination.
 * - Filters items based on selected dropdown filters.
 * - Resets filters and search when reset button is clicked.
 *
 * @since 1.0.0
 * @modified 1.1.0
 */
jQuery(document).ready(($) => {
	
	// Exit if no resource containers exist on the page
	if (!$('.elon-resources--container').length) return;
	
	// Initialize Select2 on dropdown filters with custom configuration
	$('.filter-wrap .filter-control').select2({
		minimumResultsForSearch: Infinity,
		allowClear: true
	});
	
	// Initialize tippy for file download items
	tippy('[data-tippy-content]');
	
	// Object to store resource lists by their component id
	const resourceLists = {};
	
	// Object to store filter terms for each component
	const filterTerms = {};
	
	// Object to store the configuration options for List.js
	const opts = {};
	
	// Iterate through each resource container on the page
	$('.elon-resources--container').each((index, container) => {
		
		const $container = $(container);
		const listId = $container.attr('id'); // Get the container id
		const compId = $container.data('comp-id'); // Get the component id
		const listVars = window[`elon_rm_vars_${compId}`]; // Retrieve list-specific variables from global window object
		const listKey = `list_${compId}`; // Define the list key to use in resourceLists object
		const termsKey = `terms_${compId}`; // Define the terms key for storing filter terms
		
		// Store DOM references
		const $input = $container.find('.elon-resources--search--input');
		const $resetBtnContainer = $container.find('.elon-resources--search--reset');
		const $filters = $container.find('.filter-wrap .filter-control');
		const $noResults = $container.find('.elon-resources--no-results');
		const $list = $container.find('.list');
		const $pagination = $container.find('.pagination');
		
		// Setup List.js configuration for this particular component
		const optsKey = `opts_${compId}`; // Unique key for storing options for the component
		opts[optsKey] = {
			valueNames: listVars.filter_classes, // Define the classes to use for filtering
		};
		
		// If pagination is enabled and there are more items than the specified per-page limit
		if (listVars.enable_pagination && $list.find('li').length > listVars.num_per_page) {
			opts[optsKey].page = listVars.num_per_page; // Set the number of items per page
			opts[optsKey].pagination = {
				paginationClass: 'elon-resources--pagination', // Class for pagination controls
				innerWindow: 2, // Number of pages visible on each side of the current page
				outerWindow: 1, // Number of pages visible on the outer edges of the pagination
				item: function(pageObj) {
					if (pageObj.dotted) {
						return '<li>...</li>';
					}
					// Regular page item
					return `<li><button class="page" data-page="${pageObj.page}">${pageObj.page}</button></li>`;
				}
			};
		}
		
		// Create a new List.js instance using the dynamically defined options for the component
		resourceLists[listKey] = new List(`elon-resources--container-${compId}`, opts[optsKey]);
		
		// Listen for the 'updated' event on the List.js instance to check if any items match the search/filter criteria
		resourceLists[listKey].on('updated', (list) => {
			const inputVal = $input.val().trim();
			//const isEmpty = inputVal === '';
			const isSearchActive = inputVal !== '';
			
			// Check if any filters are active
			let filtersActive = false;
			$filters.each((index, filter) => {
				if ($(filter).val() !== '') {
					filtersActive = true;
				}
			});
			
			// Determine if any items match
			const hasMatches = list.matchingItems.length > 0;
			
			if (isSearchActive || filtersActive) {
				$resetBtnContainer.removeClass('input-empty');
				
				if (hasMatches) {
					// Make sure the list is visible if there are matches (regardless of 'hide on load' setting)
					$list.removeClass('hidden');
					
					// Only show pagination if it's enabled
					if (listVars.enable_pagination) {
						$pagination.removeClass('hidden');
					}
					
					// Hide the "no results" message
					$noResults.addClass('hidden');
				} else {
					// Show the "no results" message
					$noResults.removeClass('hidden');
					
					// Hide the list and pagination if there are no matches
					$list.addClass('hidden');
					$pagination.addClass('hidden');
				}
			} else {
				$resetBtnContainer.addClass('input-empty');
				
				// If list is hidden on page load, make sure to hide it back when search is empty
				if (listVars.hide_list) {
					$list.addClass('hidden');
					$pagination.addClass('hidden');
				} else {
					$list.removeClass('hidden');
					
					// Only show pagination if it's enabled
					if (listVars.enable_pagination) {
						$pagination.removeClass('hidden');
					}
				}
				
				// Hide the "no results" message
				$noResults.addClass('hidden');
			}
		});
		
		// Store the filter terms for this component to be used later
		filterTerms[termsKey] = listVars.filter_terms;
		
		// Handle dropdown filtering: when a dropdown filter value is changed
		$filters.on('change', () => {
			$list.removeClass('hidden');
		
			const selectedFilters = {};
			
			// Loop through each filter and capture the selected values
			$filters.each((index, filter) => {
				const $filter = $(filter);
				selectedFilters[$filter.data('class')] = $filter.find('option:selected').val();
			});
			
			// Apply filtering to the list based on selected filter values
			resourceLists[listKey].filter((item) => {
				// Filter based on each selected filter's value
				return filterTerms[termsKey].every((term) => {
					const selectedValue = selectedFilters[term];
					
					// Get all spans for this filter term
					const matchingSpans = item.elm.querySelectorAll(`.${term}[data-value]`);
					
					// Flatten all data-value strings into a single array of individual values
					const itemValues = Array.from(matchingSpans).flatMap(span =>
						span.dataset.value.split(',').map(s => s.trim())
					);
					
					// Match if no filter is selected, or if the selected value exists in the item values
					return selectedValue === '' || itemValues.includes(selectedValue);
				});
			});
		});
		
		// Reset filters and search: when the reset button is clicked
		$resetBtnContainer.find('button').on('click', () => {
			// Clear the search input field
			$input.val('');
			
			// Reset the filter dropdowns and trigger change event
			$filters.val('').trigger('change');
			
			// Reset the List.js filters and search results
			resourceLists[listKey].filter();
			resourceLists[listKey].search();
			
			$resetBtnContainer.addClass('input-empty');
			
			// If the list was initially hidden, hide it again after reset
			if (listVars.hide_list) {
				$list.addClass('hidden');
				$pagination.addClass('hidden');
			}
		});
		
	});
	
});